import { Component } from "preact";
import { Button, Card } from "react-bootstrap";
import PageContent from "../../components/page-content";
import Heading from "../../components/heading";
import { Link } from "preact-router";
import PageLoader from "../../components/page-loader";
import Error from "../../components/error";
import { getUser } from "../../api/users";

export default class UserView extends Component {
    state = {
        userLoading: true,
    };

    componentDidMount() {
        this.loadUser();
    }

    loadUser() {
        getUser(this.props.id)
            .then((response) => {
                const respData = response.data;

                if (respData.success === true) {
                    const user = respData.data;
                    this.setState({ user: user, userLoading: false });
                } else {
                    this.setState({ userLoading: false, userError: respData });
                }
            })
            .catch((ex) => {
                console.error("getUser()", ex);
                this.setState({ userLoading: false, userError: ex?.response?.data ?? ex });
            });
    }

    render() {

        if (this.state.userLoading) {
            return <PageLoader message={`Chargement de l'utilisateur`} />;
        }

        if (this.state.userError) {
            return <Error message={this.state.userError?.message ?? "Une erreur est survenue"} />;
        }

        return (
            <PageContent>
                <Heading
                    title={
                        <>
                            Profil utilisateur °{this.props.id} <small className={`text-muted`}>{this.state.user.email}</small>
                        </>
                    }
                >
                    <Link href={`/users/save/${this.state.user?.id}`}>Modifier</Link>
                </Heading>

                <Card className={`animate__animated animate animate__fadeIn mt-4`}>
                    <Card.Body>Cette page est en cours de construction</Card.Body>
                </Card>
            </PageContent>
        );
    }
}
